// ─────────────────────────────────────────────────────────────────
// Glass-i — Year-End Closing + Opening Balance Voucher API client
// (Stage 6E.2).
//
// Thin axios wrappers around /api/erp/accounts/year-end-closings/*.
// The Approval-MFA challenge id flows through the standard
// `x-approval-mfa-challenge-id` header on destructive / financial
// paths (delete / post / opening-voucher / reopen).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/accounts';
const YEC  = `${BASE}/year-end-closings`;

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

function mfaHeader(challengeId) {
  return challengeId
    ? { headers: { 'x-approval-mfa-challenge-id': challengeId } }
    : undefined;
}

export const yearEndClosingApi = {
  list: (params)    => client.get(YEC, { params }).then(unwrap),
  get:  (id)        => client.get(`${YEC}/${encodeURIComponent(id)}`).then(unwrap),
  create: (payload) => client.post(YEC, payload).then(unwrap),
  update: (id, payload) =>
    client.put(`${YEC}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove: (id, { approvalMfaChallengeId } = {}) =>
    client.delete(`${YEC}/${encodeURIComponent(id)}`,
                  mfaHeader(approvalMfaChallengeId)).then(unwrap),
  preview: (id) =>
    client.post(`${YEC}/${encodeURIComponent(id)}/preview`, {}).then(unwrap),
  post: (id, { approvalMfaChallengeId } = {}) =>
    client.post(`${YEC}/${encodeURIComponent(id)}/post`, {},
                mfaHeader(approvalMfaChallengeId)).then(unwrap),
  createOpeningVoucher: (id, payload, { approvalMfaChallengeId } = {}) =>
    client.post(`${YEC}/${encodeURIComponent(id)}/opening-voucher`, payload || {},
                mfaHeader(approvalMfaChallengeId)).then(unwrap),
  reopen: (id, payload, { approvalMfaChallengeId } = {}) =>
    client.post(`${YEC}/${encodeURIComponent(id)}/reopen`, payload || {},
                mfaHeader(approvalMfaChallengeId)).then(unwrap),
  lines: (id) =>
    client.get(`${YEC}/${encodeURIComponent(id)}/lines`).then(unwrap),

  // Reuse the existing ledger lookup endpoint for the Retained
  // Earnings picker (subtype filter: capital/reserves_surplus).
  retainedEarningsLookup: (q, limit = 50) =>
    client.get(`${BASE}/ledgers/lookups/by-subtype`, {
      params: { subtype: 'capital,reserves_surplus', q, limit }
    }).then(unwrap)
};
